module.exports = __webpack_public_path__ + "static/media/iconPhone.b1aa3983.svg";